import axios from 'axios'
import { signOut, getSession } from 'next-auth/react'
import qs from 'qs'

import { env } from '@/env'

axios.defaults.paramsSerializer = params =>
  qs.stringify(params, { arrayFormat: 'brackets' })

export const api = axios.create({
  // withCredentials: true,
  baseURL: env.NEXT_PUBLIC_PGEE_API_BASE_URL,
  headers: {
    accept: 'application/json',
    'Content-Type': 'application/json'
  },
  paramsSerializer: {
    serialize: params => qs.stringify(params, { arrayFormat: 'brackets' })
  }
})

api.interceptors.request.use(async config => {
  try {
    const session = await getSession()

    if (session?.accessToken !== undefined)
      config.headers.Authorization = `Bearer ${session.accessToken}`
  } catch (error) {}

  return config
})

api.interceptors.response.use(
  response => response,
  async error => {
    // try {
    //   if (
    //     (401 == get(error, 'response.status') ||
    //       401 == get(error, 'response.data.status_code')) &&
    //     window !== undefined
    //   )
    //     return signOut({
    //       redirect: false
    //     })
    // } catch (error) {}

    return Promise.reject(error)
  }
)

// Self API
export const selfApi = axios.create({
  baseURL: '/api',
  headers: { accept: 'application/json' },
  paramsSerializer: {
    serialize: params => qs.stringify(params, { arrayFormat: 'brackets' })
  }
})
